import { render, staticRenderFns } from "./ShippingCompanyForOrderTable.vue?vue&type=template&id=42df431e&scoped=true"
import script from "./ShippingCompanyForOrderTable.vue?vue&type=script&lang=js"
export * from "./ShippingCompanyForOrderTable.vue?vue&type=script&lang=js"
import style0 from "./ShippingCompanyForOrderTable.vue?vue&type=style&index=0&id=42df431e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42df431e",
  null
  
)

export default component.exports